module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_CLARO_ICONO-08.ca96adf8.svg";